import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AZ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#AZ_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#AF0100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AZ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#AZ_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0z", fill: "#3CA5D9" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#73BE4A" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.14 15.024c-1.347-.31-2.53-1.47-2.516-3.024.014-1.455.87-2.632 2.351-2.967 1.481-.334 3.017.301 3.017.301-.408-.907-1.83-1.544-2.995-1.541-2.17.006-4.486 1.663-4.509 4.193-.023 2.623 2.473 4.114 4.67 4.108 1.762-.005 2.598-1.138 2.772-1.62 0 0-1.443.86-2.79.55zm.877-1.603l1.175-.818 1.176.818-.415-1.37 1.141-.866-1.431-.03-.47-1.352-.47 1.353-1.433.03 1.142.864-.415 1.371z",
      fill: "#F7FCFF"
    }
  )))
);
export {
  t as default
};
